module.exports = __webpack_public_path__ + "img/mapa_es.20ade6c6.jpg";